import React from 'react';
import { Container, Header, Content, Sidebar, FlexboxGrid, Message, IconButton } from 'rsuite';
import './App.scss'
import { Calculator } from './features/calculator/Calculator';
import Budget from './features/budget/Budget';
import Logo from './images/logo.svg'
import { recalcValues, resetValues } from './features/calculator/calculatorSlice';
import { useAppDispatch } from './store/hooks';
import { Settings } from './features/settings';
import Modal from './Components/Modal';
import {MdUTurnLeft} from "react-icons/md";
const HeaderContent = () => {
  const dispatch = useAppDispatch();
  const handleButtonClick = () => {
    dispatch(resetValues())
    dispatch(recalcValues())
  }
  return <FlexboxGrid justify="end" align="middle" className="header_content">
    <FlexboxGrid.Item colspan={16}><h3>Cambium Fiber Link Budget Calculator</h3></FlexboxGrid.Item>
    <FlexboxGrid.Item colspan={4} className="header_content__buttons">
      <IconButton
        className="rs-btn-cambium rs-btn-cambium-icon"
        icon={<MdUTurnLeft size={22} style={{transform: 'rotate(90deg)'}}/>}
        onClick={handleButtonClick}
      >
        Reset
      </IconButton>
      <Settings />
    </FlexboxGrid.Item>
  </FlexboxGrid>
}
function App() {
  return (
    <>
      <Modal />
      <div className="show-container">
        <Container>
          <FlexboxGrid justify="start" align="middle" className="logo_section">
            <FlexboxGrid.Item colspan={12}><img id="cambium-logo" src={Logo} alt="Cambium Networks" /></FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={12}><Message><p>Please note that this link calculator is a free tool and is provided as-is. While we have made every effort to ensure its accuracy, we do not guarantee that the calculations are error-free or
              suitable for any particular purpose. By using this tool, you acknowledge and agree that you assume all risk and responsibility for any consequences arising from its use.</p></Message></FlexboxGrid.Item>
          </FlexboxGrid>
        </Container>
        <Container>
          <Header><HeaderContent /></Header>
          <Container>
            <Sidebar><Calculator /></Sidebar>
            <Content><Budget /></Content>
          </Container>
        </Container>
      </div>
    </>
  );
}

export default App;
